// import i18n from '@/i18n';
import {goTo} from '@/utils';
import globalStore from '@/services/global.state';
import {getPick11GameUrl} from './home.service';

export type Pick11EntryGameType = 'PICK11' | 'PICK6';

export interface OpenPick11Options {
  matchId?: number;
  gameType?: Pick11EntryGameType | string | null;
}

export function normalizePickEntryType(
  raw?: string | null,
): Pick11EntryGameType | undefined {
  const value = raw?.trim().toUpperCase();
  if (!value) {
    return undefined;
  }
  const normalizedMap: Record<string, Pick11EntryGameType> = {
    DREAM11: 'PICK11',
    PICK11: 'PICK11',
    DREAM6: 'PICK6',
    PICK6: 'PICK6',
  };
  return normalizedMap[value];
}

function appendQueryParams(
  baseUrl: string,
  {matchId, gameType}: OpenPick11Options,
) {
  const normalizedGameType = normalizePickEntryType(gameType);
  try {
    const url = new URL(baseUrl);
    if (matchId != null) {
      url.searchParams.set('matchId', `${matchId}`);
    }
    if (normalizedGameType) {
      url.searchParams.set('gameType', normalizedGameType);
    }
    return url.toString();
  } catch {
    let nextUrl = baseUrl;
    const appendParam = (key: string, value: string) => {
      const hasQuery = nextUrl.includes('?');
      const separator = !hasQuery
        ? '?'
        : nextUrl.endsWith('?') || nextUrl.endsWith('&')
        ? ''
        : '&';
      const pattern = new RegExp(`([?&])${key}=[^&]*`);
      if (pattern.test(nextUrl)) {
        nextUrl = nextUrl.replace(pattern, `$1${key}=${value}`);
        return;
      }
      nextUrl = `${nextUrl}${separator}${key}=${value}`;
    };
    if (matchId != null) {
      appendParam('matchId', `${matchId}`);
    }
    if (normalizedGameType) {
      appendParam('gameType', normalizedGameType);
    }
    return nextUrl;
  }
}

/**
 * 打开 Pick11 页面（与金刚区、Pick11 楼层共用流程）
 * - 未登录则跳转登录
 * - 调用 getPick11GameUrl 拿到地址后打开 WebView
 * - 支持在地址上拼接 matchId / gameType 查询参数
 */
export function openPick11(options?: number | OpenPick11Options): void {
  const pick11Options =
    typeof options === 'number' ? {matchId: options} : options || {};

  if (!globalStore.tokenSubject.getValue()) {
    goTo('Login');
    return;
  }
  globalStore.globalLoading.next(true);
  getPick11GameUrl()
    .then(res => {
      const baseUrl =
        typeof res === 'string' ? res : (res as {token?: string})?.token ?? '';
      if (!baseUrl) {
        console.log('no Pick11 game url');
        return;
      }
      const url = appendQueryParams(baseUrl, pick11Options);
      goTo('WebView', {
        header: false,
        hideAmount: true,
        headerTitle: 'Pick11',
        originUrl: url,
      });
    })
    .catch(() => {
      // globalStore.globalWaringTotal(
      //   i18n.t('home.pick11.no-token') || 'Failed to get game token',
      // );
      console.log('Failed to get Pick11 game token');
    })
    .finally(() => {
      globalStore.globalLoading.next(false);
    });
}
